export default "__VITE_ASSET__DwDxmrY0__"